import { Toaster as Sonner, toast } from "sonner"

const Toaster = ({
  ...props
}) => {
  return (
    <Sonner
      theme="dark"
      className="toaster group"
      closeButton={true}
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-[#0A0A35] group-[.toaster]:text-white group-[.toaster]:border-[#1E1E5F] group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-slate-400",
          actionButton:
            "group-[.toast]:bg-[#42E695] group-[.toast]:text-[#04042C]",
          cancelButton:
            "group-[.toast]:bg-slate-700 group-[.toast]:text-slate-300",
          closeButton:
            "group-[.toast]:bg-transparent group-[.toast]:text-slate-400 group-[.toast]:hover:text-white group-[.toast]:border-slate-600",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
